import React, { FC, ReactElement} from 'react';
import styles from './index.less'

interface IProps {
  look?: boolean,
  train?: boolean,
  wave?: boolean,
  circle?: boolean
}

const BgTitle: FC<IProps> = (props:IProps): ReactElement => {

  const { look, train, wave, circle } = props

  return (
    <div className={styles.bgTitle}>
      {look && <div className={styles.lookLook}></div>}
      {train && <div className={styles.trainTrain}></div>}
      {wave && <div className={styles.wave}></div>}
      {circle && <div className={styles.circle}></div>}
    </div>
  )
}

export default BgTitle